import { createSignal } from "solid-js";
import type { DeliveryBrief } from "./briefTypes";

type BriefDrafts = Record<string, Record<string, DeliveryBrief>>;
type IssueBriefSources = Record<string, string[]>;

const [briefDrafts, setBriefDrafts] = createSignal<BriefDrafts>({});
const [issueBriefSources, setIssueBriefSources] =
  createSignal<IssueBriefSources>({});

export function sessionIssueBriefIds(websiteId: string): string[] {
  return issueBriefSources()[websiteId] ?? [];
}

export function hasSessionIssueBrief(
  websiteId: string,
  issueId: string,
): boolean {
  return sessionIssueBriefIds(websiteId).includes(issueId);
}

export function registerSessionIssueBrief(
  websiteId: string,
  issueId: string,
): void {
  setIssueBriefSources((current) => {
    const existing = current[websiteId] ?? [];
    if (existing.includes(issueId)) return current;
    return { ...current, [websiteId]: [...existing, issueId] };
  });
}

export function sessionBriefDraft(
  websiteId: string,
  briefId: string,
): DeliveryBrief | null {
  return briefDrafts()[websiteId]?.[briefId] ?? null;
}

export function hasSessionBriefDraft(
  websiteId: string,
  briefId: string,
): boolean {
  return Boolean(briefDrafts()[websiteId]?.[briefId]);
}

export function setSessionBriefDraft(
  websiteId: string,
  brief: DeliveryBrief,
): void {
  setBriefDrafts((current) => ({
    ...current,
    [websiteId]: {
      ...current[websiteId],
      [brief.id]: brief,
    },
  }));
}

export function resetSessionBriefDraft(
  websiteId: string,
  briefId: string,
): void {
  setBriefDrafts((current) => {
    const websiteDrafts = { ...current[websiteId] };
    delete websiteDrafts[briefId];
    return { ...current, [websiteId]: websiteDrafts };
  });
}
